import { useQuery } from '@tanstack/react-query';

import { apiClient, type Decoration } from '@api';
import { QueryKeys } from '@config';

/**
 * Retrieves available decorations for a venue.
 *
 * Required params: venue identifier.
 * Important behavior: query is disabled until venueId is truthy; normalizes response to Decoration[].
 *
 * @example
 * const { data: decorations } = useGetVenueDecorations(venueId);
 */
export const useGetVenueDecorations = (
  venueId: string,
  options: object = {}
) => {
  return useQuery<Decoration[]>({
    queryKey: [QueryKeys.VENUES, QueryKeys.VENUE_DECORATIONS, venueId],
    queryFn: async () => {
      const response = await apiClient.venuesDecorationsRetrieve({
        path: { identifier: venueId },
      });
      // API returns an array but type says single Decoration
      return response.data as unknown as Decoration[];
    },
    enabled: !!venueId,
    ...options,
  });
};
